var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['Search']}},[_c('router-view')],1),_c('AppTabBar',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.isShowTabbar),expression:"$route.meta.isShowTabbar"}]}),_c('ChangeDealer'),(_vm.nodeEnv !== 'production')?_c('MockLogin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }